module.exports = "<div class=\"container\"></div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/admin/admin.html
// module id = 160
// module chunks = 0